'use client'
import type { Data } from '@repo/strapi'
import type React from 'react'
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import { Container } from '@/components/elementary/Container'
import { BasicImage } from '@/components/page-builder/components/BasicImage'
import Heading from '@/components/typography/Heading'
import { cn } from '@/lib/styles'
import { ERROR_VIEW_TEST_IDS } from '@/lib/test-ids'

export function ErrorView({
	data,
	children,
	disableTopMargin = false,
}: {
	readonly data?:
		| Data.ContentType<'api::not-found.not-found'>
		| Data.ContentType<'api::no-result.no-result'>
		| null
	readonly disableTopMargin?: boolean
	children?: React.ReactNode
}) {
	const { image, title, description } = data ?? {}

	return (
		<Container
			className={cn(
				'flex justify-center items-center px-3 min-h-screen-minus-16 lg:min-h-screen-minus-25',
				!disableTopMargin && 'mt-16 lg:mt-25',
			)}
			paddingY
			data-test-id={ERROR_VIEW_TEST_IDS.COMPONENT}
		>
			<div className="max-w-170 text-center flex justify-center flex-col items-center">
				{image && <BasicImage component={image} className="object-contain mb-4" />}

				<Heading tag="h1" fontSize="displayLarge" className="mb-2">
					{title}
				</Heading>
				<CkEditorCSRRenderer variant="textOnly" htmlContent={description} />
				{children && <div className="mt-4 w-full">{children}</div>}
			</div>
		</Container>
	)
}
